<template>
    <div class="modal" :class="{active: modal}">
        <div class="modal_dimmer">
            <div class="modal_content">

                <h2 class="modal_title">{{ title }}</h2>
                
                <a href="#0" class="closeBtn" @click.prevent="toggleModal()">
                    <ion-icon name="close-circle"></ion-icon>
                </a>

                <!--Listings-->
                <div v-if="type === 'createNewAd'" class="formArea">
                    <form v-if="!formSuccess" @submit="checkForm" action="" method="post">

                        <p class="formLabel">Category:</p>
                        <select v-model="form.category" :class="{error: formErrors.category === 'error'}">
                            <option value="">-- Select Category --</option>
                            <option value="jobs">Jobs</option>
                            <option value="buy_sell">Buy &amp; Sell</option>
                            <option value="home_garden">Home &amp; Garden</option>
                            <option value="clothing_accessories">Clothing &amp; Accessories</option>
                            <option value="electronics">Electronics</option>
                            <option value="family">Family</option>
                            <option value="classifieds">Classifieds</option>
                            <option value="hobbies">Hobbies</option>
                            <option value="entertainment">Entertainment</option>
                            <option value="home_sales">Home Sales</option>
                            <option value="vehicle_sales">Vehicle Sales</option>
                            <option value="other">Other</option>
                        </select>

                        <div class="backgrounds">
                            <p class="formLabel">Background color:</p>
                            <div v-for="(gradient, index) in gradients" :key="index" class="background" :style="gradient" @click.prevent="form.background = index" :class="{active: form.background === index}"></div>
                        </div>

                        <p class="formLabel">Title:</p>
                        <input v-model="form.title" type="text" placeholder="Title" :class="{error: formErrors.title === 'error'}" />

                        <p class="formLabel">Price:</p>
                        <input v-model="form.price" type="text" placeholder="Price" :class="{error: formErrors.price === 'error'}" />
                        
                        <p class="formLabel">Content:</p>
                        <textarea v-model="form.content" placeholder="Add content here..." :class="{error: formErrors.content === 'error'}"></textarea>

                        <input type="submit" value="Create" class="btn green" />

                        <div v-if="formErrorMsg !== ''" class="msg error">
                            <p>{{ formErrorMsg }}</p>
                        </div>

                    </form>
                    <div v-else-if="formSuccess" class="successArea">
                        <div>
                            <ion-icon name="checkmark-circle"></ion-icon>
                            <h3>Successfully created!!!</h3>
                            <p>Your ad was successfully created.</p>
                        </div>
                    </div>
                </div>

                <!--Videos-->
                <div v-if="type === 'createNewVideo'" class="formArea">
                    <form v-if="!formSuccess" @submit="checkForm" action="" method="post">

                        <p class="formLabel">Category:</p>
                        <select v-model="form.category" :class="{error: formErrors.category === 'error'}">
                            <option value="">-- Select Category --</option>
                            <option value="stories">Stories</option>
                            <option value="other">Other</option>
                        </select>

                        <p class="formLabel">Title:</p>
                        <input v-model="form.title" type="text" placeholder="Title" :class="{error: formErrors.title === 'error'}" />

                        <p class="formLabel">Video Url:</p>
                        <input v-model="form.videoUrl" @change="checkVideoUrl" type="text" placeholder="Paste Youtube or Vimeo video url" :class="{error: formErrors.videoUrl === 'error'}" />

                        <div v-if="form.data !== null" class="videoPreview">
                            <div class="embedType">
                                <!-- <iframe :src="form.data.embedUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen style="width:100%;min-height:250px;"></iframe> -->
                                <vue-plyr>
                                    <div :data-plyr-provider="form.data.type.toLowerCase()" :data-plyr-embed-id="form.data.id"></div>
                                </vue-plyr>
                            </div>
                        </div>

                        <p class="formLabel">Content:</p>
                        <textarea v-model="form.content" placeholder="Add content here..." :class="{error: formErrors.content === 'error'}"></textarea>

                        <input type="submit" value="Create" class="btn green" />

                        <div v-if="formErrorMsg !== ''" class="msg error">
                            <p>{{ formErrorMsg }}</p>
                        </div>
                    </form>
                    <div v-else-if="formSuccess" class="successArea">
                        <div>
                            <ion-icon name="checkmark-circle"></ion-icon>
                            <h3>Successfully created!!!</h3>
                            <p>Your video was successfully created.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
    data(){
        return{
            modal: false,
            form: {
                title: '',
                content: '',
                category: '',
                data: null,
                background: 0
            },
            formErrors: {},
            formErrorMsg: '',
            formSuccess: false,
            gradients: [
                'background-color: #FFE53B;background-image: linear-gradient(147deg, #FFE53B 0%, #FF2525 74%);',
                'background-color: #08AEEA;background-image: linear-gradient(0deg, #08AEEA 0%, #2AF598 100%);',
                'background-color: #FAACA8;background-image: linear-gradient(19deg, #FAACA8 0%, #DDD6F3 100%);',
                'background-color: #FF9A8B;background-image: linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%);',
                'background-color: #4158D0;background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);',
                'background-color: #0cbaba;background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);'
            ]
        }
    },

    props: {
        title: String,
        type: String
    },

    created(){
        document.addEventListener('keyup', (e) => {
            if (e.keyCode === 27) {
                this.modal = false
                this.resetForm()
            }
        })
    },

    mounted(){
        this.resetFormFields()
    },
    
    methods: {
        // Form default logic
        toggleModal(){
            this.resetForm()
            this.resetFormFields()
            this.modal = !this.modal
        },
        resetForm(){
            this.formErrors = {}
            this.formErrorMsg = ''
            this.formSuccess = false
        },
        checkForm(e){
            e.preventDefault()
            
            this.formErrors = {}
            this.formErrorMsg = ''

            // Check All Fields
            Object.keys(this.form).forEach(key => {
                
                // General Fields
                if(this.form[key] === ''){
                    this.formErrors[key] = 'error'
                
                // Custom Fields
                }else{
                    if(key === 'videoUrl'){
                        let videoUrlData = this.getIframeUrl(this.form[key])

                        if(videoUrlData.valid){
                            this.form['data'] = videoUrlData
                        }else{
                            this.formErrors[key] = 'error'
                        }
                    }
                }
            })

            // Report Errors
            if(Object.keys(this.formErrors).length > 0){
                this.formErrorMsg = 'Please fill all required fields.'
                return
            }else{
                this.create()
            }
        },
        resetFormFields(check){

            this.form = {
                title: '',
                content: '',
                category: '',
                data: null,
                background: 0
            }

            // Reset default form fields
            if(this.type === 'createNewVideo'){
                this.form.videoUrl = ''
            }else{
                this.form.price = ''
            }

            this.formErrors = {}
            this.formErrorMsg = ''

            if(check){
                this.formSuccess = true
            }else{
                this.formSuccess = false
            }
        },
        checkVideoUrl(){
            if(typeof this.form.videoUrl !== 'undefined'){
                if(this.form.videoUrl !== ''){
                    let videoData = this.getIframeUrl(this.form.videoUrl)
                
                    if(videoData.valid){
                        this.form.data = videoData
                    }
                }else{
                    this.form.data = null
                }
            }
        },
        getIframeUrl(url){

            let urlData = {
                url: url,
                valid: false
            }

            console.log('Check url: ', url)

            const youtubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
            const vimeoRegExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/
            const isYoutube = url.match(youtubeRegExp)
            const isVimeo = url.match(vimeoRegExp)

            console.log('is vimeo: ', isVimeo)

            if(isYoutube && isYoutube[2].length === 11){
                if(typeof isYoutube[2] !== 'undefined'){

                    urlData.id = isYoutube[2]
                    urlData.type = 'youtube'
                    urlData.embedUrl = 'https://www.youtube.com/embed/' + isYoutube[2]
                    urlData.thumbnail = 'https://img.youtube.com/vi/'+ isYoutube[2] +'/maxresdefault.jpg'
                    urlData.valid = true
                }
            }else if(isVimeo){
                if(typeof isVimeo[3] !== 'undefined'){

                    urlData.id = isVimeo[3]
                    urlData.type = 'vimeo'
                    urlData.embedUrl = 'https://player.vimeo.com/video/' + isVimeo[3]
                    urlData.thumbnail = ''
                    urlData.valid = true
                }
            }

            console.log('Video data: ', urlData)
            
            return urlData
        },

        // Custom Modal logic
        create(){
            if(this.type === 'createNewAd'){
                this.postNewAd()
            }else if(this.type === 'createNewVideo'){
                this.postNewVideo()
            }else if(this.type === 'createNewPost'){
                this.postNewPost()
            }
        },
        postNewAd(){

            let ref = fb.adsCollection

            this.form.authorId = this.$store.state.currentUser.uid
            this.form.authorName = this.$store.state.userProfile.firstName
            this.form.authorImage = this.$store.state.currentUser.photoURL
            this.form.timestamp = fb.firebase.firestore.FieldValue.serverTimestamp()
            let title = this.form.title

            ref.add(this.form).then(docRef => {

                this.resetFormFields(true)
                this.$emit('refresh')

                let message = title
                // this.addNewActivity(message, docRef.id)

                this.$notify({
                    group: 'globalNotifications',
                    title: 'Successfully ' + message
                })
            })
            .catch(err => {
                console.log('Error creating new ad: ', err)
                this.formErrorMsg = 'Error creating a new listing!'
            })
        },
        postNewVideo(){

            let ref = fb.videosCollection
            
            this.form.uid = this.$store.state.currentUser.uid
            this.form.timestamp = fb.firebase.firestore.FieldValue.serverTimestamp()
            let title = this.form.title

            ref.add(this.form).then(docRef => {

                this.resetFormFields(true)
                this.$emit('refresh')

                let message = title
                // this.addNewActivity(message, docRef.id)

                this.$notify({
                    group: 'globalNotifications',
                    title: 'Successfully ' + message
                })
            })
            .catch(err => {
                console.log('Error creating new video: ', err)
                this.formErrorMsg = 'Error creating a new video!'
            })
        },
        addNewActivity(message, itemId){

            let activityRef = fb.activitiesCollection
            let path = ''
            let type = ''

            if(this.type === 'createNewAd'){
                type = 'listings'
                path = '/listings?item='+ itemId 
            }else if(this.type === 'createNewVideo'){
                type = 'videos'
                path = '/videos?item='+ itemId
            }

            let newActivity = {
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                uid: this.$store.state.currentUser.uid,
                message: message,
                path: path,
                to: 'all',
                type: type,
                itemId: itemId,
                seen: false
            }

            activityRef.add(newActivity).then(doc => {
                console.log('New activity created with id: ', doc.id)
            })
            .catch(err => {
                console.log('Error creating new activity: ', err)
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Modal.vue